module.exports = __webpack_public_path__ + "static/media/bell.25117e21.svg";